export default function (state, getters, rootState, rootGetters) {
    return (getters.pay_edit && !rootGetters.permission(68))
}